import request from 'checkout/utils/axios'

const getMiniCartServices = async params => {
  const response = await request.get(`/api/v3/crosses/services${params}`)

  return response
}

export default getMiniCartServices
